const VIDEO_MIME_PREFIX = 'video/';
const VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm', 'm4v'];

const extensionFromValue = (value?: string): string => {
  if (!value) return '';
  const withoutQuery = value.split('#')[0].split('?')[0];
  const base = withoutQuery.split('/').filter(Boolean).pop() || '';
  const dotIndex = base.lastIndexOf('.');
  if (dotIndex < 0) return '';
  return base.slice(dotIndex + 1).toLowerCase();
};

const isVideoAttachment = (attachment: { mimetype?: string; name?: string; url?: string }): boolean => {
  const mimetype = (attachment?.mimetype || '').toLowerCase();
  if (mimetype.startsWith(VIDEO_MIME_PREFIX)) return true;

  const extension = extensionFromValue(attachment?.name) || extensionFromValue(attachment?.url);
  return VIDEO_EXTENSIONS.includes(extension);
};

export default isVideoAttachment;
